import { render, staticRenderFns } from "./MarketInfoHome.vue?vue&type=template&id=242151df&scoped=true"
import script from "./MarketInfoHome.vue?vue&type=script&lang=js"
export * from "./MarketInfoHome.vue?vue&type=script&lang=js"
import style0 from "./MarketInfoHome.vue?vue&type=style&index=0&id=242151df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242151df",
  null
  
)

export default component.exports